<template>
    <div class="nevs-content">
        <ModalActivity @done="activityModalDone" :show="activityModal.show"
                       :activityId="activityModal.activityId"></ModalActivity>
        <ModalActivityInvoice @done="activityInvoiceModalDone" :show="activityInvoiceModal.show"></ModalActivityInvoice>
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsButton class="primary" @click="previewAccessClick">
                <i class="fa-solid fa-eye"></i>
                {{ $LANG.Get('modules.activityPreviewAccess') }}
            </NevsButton>
            <NevsButton class="primary" @click="createInvoiceClick">
                <i class="fa-solid fa-file-invoice"></i>
                {{ $LANG.Get('modules.createInvoiceFromActivities') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsTextField v-model="tableData.filters.name" :label="$LANG.Get('fields.name')"></NevsTextField>
                <NevsSelect :nullable="true" v-model="tableData.filters.customer_id" :ajax="'select/customers'"
                            :label="$LANG.Get('fields.customer')"
                            @select="filterLabels.customer_id = $event.label"></NevsSelect>
                <NevsSelect :nullable="true" v-model="tableData.filters.product_id" :ajax="'select/products'"
                            :label="$LANG.Get('fields.product')"
                            @select="filterLabels.product_id = $event.label"></NevsSelect>
                <NevsDateField v-model="tableData.filters.date_from"
                               :label="$LANG.Get('fields.dateFrom')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.date_to"
                               :label="$LANG.Get('fields.dateTo')"></NevsDateField>
                <NevsSelect v-model="tableData.filters.invoiced" :label="$LANG.Get('fields.invoiced')"
                            :options="$HELPERS.GetYesNoAllOptions(this)"></NevsSelect>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.date_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.customer_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.product_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.quantity }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.invoiced_display }}</td>
                    <td class="nevs-table-actions">
                        <NevsActions :width="'200px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";
import ModalActivity from "@/components/modals/ModalActivity.vue";
import ModalActivityInvoice from "@/components/modals/ModalActivityInvoice.vue";

export default {
    name: "ModuleActivities",
    components: {NevsTableFilters, ModalActivityInvoice, ModalActivity, NevsActions, NevsSelect, NevsDateField, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            activityModal: {
                show: false,
                activityId: null
            },
            activityInvoiceModal: {
                show: false
            },
            tableData: {
                fields: [
                    {
                        name: 'date',
                        label: this.$LANG.Get('fields.date')
                    },
                    {
                        name: 'customer',
                        label: this.$LANG.Get('fields.customer'),
                        sortable: false
                    },
                    {
                        name: 'name',
                        label: this.$LANG.Get('fields.name')
                    },
                    {
                        name: 'product',
                        label: this.$LANG.Get('fields.product'),
                        sortable: false
                    },
                    {
                        name: 'quantity',
                        label: this.$LANG.Get('fields.quantity')
                    },
                    {
                        name: 'invoiced',
                        label: this.$LANG.Get('fields.invoiced'),
                        sortable: false
                    },
                    {
                        name: 'actions',
                        width: '100px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    name: '',
                    customer_id: null,
                    product_id: null,
                    date_from: null,
                    date_to: null,
                    invoiced: -1
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'date',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.delete'),
                    action: (item) => {
                        this.deleteClick(item);
                    },
                    visible: () => {
                        return true;
                    }
                }
            ],
            // Labels of the select filters, for the collapsed filter panel's summary. v-model only
            // carries the id, so the label is captured from NevsSelect's `select` event.
            filterLabels: {
                customer_id: '',
                product_id: ''
            },
            crossTabHandle: null
        }
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed
        // here and the panel picks the active ones.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'name',
                    label: this.$LANG.Get('fields.name'),
                    value: filters.name
                },
                {
                    name: 'customer_id',
                    label: this.$LANG.Get('fields.customer'),
                    value: filters.customer_id === null ? '' : this.filterLabels.customer_id
                },
                {
                    name: 'product_id',
                    label: this.$LANG.Get('fields.product'),
                    value: filters.product_id === null ? '' : this.filterLabels.product_id
                },
                {
                    name: 'date_from',
                    label: this.$LANG.Get('fields.dateFrom'),
                    value: filters.date_from === null ? '' : this.$HELPERS.FormatDate(filters.date_from)
                },
                {
                    name: 'date_to',
                    label: this.$LANG.Get('fields.dateTo'),
                    value: filters.date_to === null ? '' : this.$HELPERS.FormatDate(filters.date_to)
                },
                {
                    name: 'invoiced',
                    label: this.$LANG.Get('fields.invoiced'),
                    value: filters.invoiced === -1 ? '' : this.$LANG.Get(filters.invoiced === 1 ? 'options.yes' : 'options.no')
                }
            ];
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        deleteClick(activity) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.activityDeletionQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'activities/' + activity.id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-activities', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        createInvoiceClick() {
            this.activityInvoiceModal.show = true;
        },
        activityInvoiceModalDone(data) {
            this.activityInvoiceModal.show = false;
            if (data !== null) {
                let route = this.$router.resolve('/invoices/0/activities-' + data.customerId + '-' + data.dateFrom + '-' + data.dateTo);
                window.open(route.href, '_blank');
            }
        },
        previewAccessClick() {
            this.$router.push('/activities-preview-access');
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                name: '',
                customer_id: null,
                product_id: null,
                date_from: null,
                date_to: null,
                invoiced: -1
            };
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.calculateTableHeight();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'activities/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        addClick() {
            this.activityModal.activityId = null;
            this.$nextTick(() => {
                this.activityModal.show = true;
            });
        },
        openClick(id) {
            this.activityModal.activityId = id;
            this.$nextTick(() => {
                this.activityModal.show = true;
            });
        },
        activityModalDone(success) {
            this.activityModal.show = false;
            this.activityModal.activityId = null;
            if (success) {
                this.$CROSS_TAB_BUS.TriggerEvent('reload-activities', {});
            }
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'activities', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                    vm.$nextTick(() => {
                        vm.calculateTableHeight();
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.calculateTableHeight();
        },
        calculateTableHeight() {
            let offset = 205;
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'activities');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.activities'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-activities', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}
</style>
